module.exports = __webpack_public_path__ + "img/zcff.30fc8260.png";